import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "column-cell" }
const _hoisted_2 = { class: "column-cell" }
const _hoisted_3 = { class: "column-cell" }
const _hoisted_4 = { class: "column-cell" }
const _hoisted_5 = {
  key: 0,
  class: "field-option-description"
}
const _hoisted_6 = { class: "column-cell" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_DialogDelete = _resolveComponent("DialogDelete")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DataTable, {
      value: _ctx.rows,
      loading: _ctx.loading,
      class: "p-datatable-sm p-datatable-documents editable-cells-table",
      autoLayout: true,
      columnResizeMode: "fit",
      dataKey: "id",
      selection: _ctx.selectedPrompts,
      "onUpdate:selection": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedPrompts) = $event)),
      editMode: "cell",
      onCellEditInit: _ctx.onCellEditInit,
      onCellEditComplete: _ctx.onCellEditComplete,
      onRowDblclick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openEntryDialog($event.data))),
      scrollable: true,
      scrollHeight: "flex",
      removableSort: true,
      filterDisplay: "row",
      filters: _ctx.filters,
      "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters) = $event)),
      onFilter: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onFilter($event))),
      paginator: true,
      rows: _ctx.pageSize,
      paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
      rowsPerPageOptions: [25,50,100],
      currentPageReportTemplate: '{first} ' + _ctx.$t('Squeeze.General.To') + ' {last} ' + _ctx.$t('Squeeze.General.Of') + ' {totalRecords}',
      onPage: _ctx.onChangePage
    }, {
      loading: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.General.Loading')), 1)
      ]),
      empty: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.General.NoEntriesFound', { entryName: _ctx.$t('Squeeze.Prompts.Prompts') })), 1)
      ]),
      paginatorstart: _withCtx(() => [
        _createVNode(_component_Button, {
          label: _ctx.$t('Squeeze.General.NewEntry'),
          type: "button",
          icon: "mdi mdi-plus",
          class: "p-button",
          disabled: !_ctx.hasLlmClass,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openEntryDialog({})))
        }, null, 8, ["label", "disabled"]),
        (_ctx.isFilterActive)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              label: _ctx.$t('Squeeze.General.ClearFilters'),
              type: "button",
              icon: "mdi mdi-filter-off-outline",
              class: "p-button p-ml-2",
              onClick: _ctx.clearFilters
            }, null, 8, ["label", "onClick"]))
          : _createCommentVNode("", true),
        (!_ctx.context)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              label: _ctx.exportLabel,
              type: "button",
              icon: "mdi mdi-file-download-outline",
              class: "p-button p-ml-2",
              loading: _ctx.exporting,
              disabled: !_ctx.selectedPrompts.length,
              onClick: _ctx.exportPrompts
            }, null, 8, ["label", "loading", "disabled", "onClick"]))
          : _createCommentVNode("", true),
        (!_ctx.context)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 2,
              label: _ctx.$t('Squeeze.Prompts.Import'),
              type: "button",
              icon: "mdi mdi-file-upload-outline",
              class: "p-button p-ml-2",
              loading: _ctx.importing,
              onClick: _ctx.importPrompts
            }, null, 8, ["label", "loading", "onClick"]))
          : _createCommentVNode("", true)
      ]),
      paginatorend: _withCtx(() => [...(_cache[7] || (_cache[7] = []))]),
      default: _withCtx(() => [
        (!_ctx.context)
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 0,
              selectionMode: "multiple",
              headerClass: "header-center",
              style: {"min-width":"3rem","max-width":"3rem","text-align":"center"}
            }))
          : _createCommentVNode("", true),
        (!_ctx.context)
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 1,
              field: "id",
              header: "ID",
              filterField: "id",
              sortable: true,
              showFilterMenu: false,
              style: {"min-width":"4rem","max-width":"5rem"}
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.id), 1)
              ]),
              filter: _withCtx(({filterModel, filterCallback}) => [
                _createVNode(_component_InputText, {
                  class: "p-column-filter filter-field",
                  type: "text",
                  modelValue: filterModel.value,
                  "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                  onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
                  style: {"min-width":"3rem"}
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_ctx.context)
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 2,
              field: "documentClassId",
              filterField: "documentClassId",
              header: _ctx.$t('Squeeze.XmlMapper.DocumentClass'),
              sortable: true,
              showFilterMenu: false,
              style: {"min-width":"10rem"}
            }, {
              body: _withCtx((slotProps) => [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createTextVNode(_toDisplayString(_ctx.getDocumentClassName(slotProps.data.documentClassId)), 1)
                ])), [
                  [
                    _directive_tooltip,
                    _ctx.getDocumentClassName(slotProps.data.documentClassId),
                    void 0,
                    { bottom: true }
                  ]
                ])
              ]),
              editor: _withCtx((slotProps) => [
                _createVNode(_component_Dropdown, {
                  modelValue: slotProps.data.documentClassId,
                  "onUpdate:modelValue": ($event: any) => ((slotProps.data.documentClassId) = $event),
                  options: _ctx.documentClassOptions,
                  optionValue: "id",
                  optionLabel: "label",
                  filter: true,
                  showClear: true,
                  placeholder: _ctx.$t('Squeeze.Prompts.Wildcard'),
                  onChange: _ctx.onCellValueChanged,
                  onShow: _ctx.showDropdownOverlay
                }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "placeholder", "onChange", "onShow"])
              ]),
              filter: _withCtx(({filterModel, filterCallback}) => [
                _createVNode(_component_Dropdown, {
                  modelValue: filterModel.value,
                  "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                  onChange: ($event: any) => (filterCallback()),
                  options: _ctx.documentClassOptions,
                  optionValue: "id",
                  optionLabel: "label",
                  class: "p-column-filter filter-field",
                  showClear: true,
                  filter: true,
                  onShow: _ctx.showDropdownOverlay
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "options", "onShow"])
              ]),
              _: 1
            }, 8, ["header"]))
          : _createCommentVNode("", true),
        _createVNode(_component_Column, {
          field: "company",
          filterField: "company",
          header: _ctx.$t('Squeeze.XmlMapper.Company'),
          sortable: true,
          showFilterMenu: false,
          style: {"min-width":"9rem"}
        }, {
          body: _withCtx((slotProps) => [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createTextVNode(_toDisplayString(_ctx.getOptionLabel(_ctx.companyOptions, slotProps.data.company)), 1)
            ])), [
              [
                _directive_tooltip,
                _ctx.getOptionLabel(_ctx.companyOptions, slotProps.data.company),
                void 0,
                { bottom: true }
              ]
            ])
          ]),
          editor: _withCtx((slotProps) => [
            (_ctx.companyOptions.length)
              ? (_openBlock(), _createBlock(_component_Dropdown, {
                  key: 0,
                  modelValue: slotProps.data.company,
                  "onUpdate:modelValue": ($event: any) => ((slotProps.data.company) = $event),
                  options: _ctx.companyOptions,
                  optionValue: "id",
                  optionLabel: "label",
                  filter: true,
                  showClear: true,
                  placeholder: _ctx.$t('Squeeze.Prompts.Wildcard'),
                  onChange: _ctx.onCellValueChanged,
                  onShow: _ctx.showDropdownOverlay
                }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "placeholder", "onChange", "onShow"]))
              : (_openBlock(), _createBlock(_component_InputText, {
                  key: 1,
                  modelValue: slotProps.data.company,
                  "onUpdate:modelValue": ($event: any) => ((slotProps.data.company) = $event),
                  placeholder: _ctx.$t('Squeeze.Prompts.Wildcard'),
                  onInput: _ctx.onCellValueChanged
                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "onInput"]))
          ]),
          filter: _withCtx(({filterModel, filterCallback}) => [
            _createVNode(_component_InputText, {
              class: "p-column-filter filter-field",
              type: "text",
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
              style: {"min-width":"8rem"}
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "creditor",
          filterField: "creditor",
          header: _ctx.$t('Squeeze.Prompts.Creditor'),
          sortable: true,
          showFilterMenu: false,
          style: {"min-width":"9rem"}
        }, {
          body: _withCtx((slotProps) => [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createTextVNode(_toDisplayString(_ctx.getOptionLabel(_ctx.creditorOptions, slotProps.data.creditor)), 1)
            ])), [
              [
                _directive_tooltip,
                _ctx.getOptionLabel(_ctx.creditorOptions, slotProps.data.creditor),
                void 0,
                { bottom: true }
              ]
            ])
          ]),
          editor: _withCtx((slotProps) => [
            (_ctx.creditorOptions.length)
              ? (_openBlock(), _createBlock(_component_Dropdown, {
                  key: 0,
                  modelValue: slotProps.data.creditor,
                  "onUpdate:modelValue": ($event: any) => ((slotProps.data.creditor) = $event),
                  options: _ctx.creditorOptionsFor(slotProps.data),
                  optionValue: "id",
                  optionLabel: "label",
                  filter: true,
                  showClear: true,
                  placeholder: _ctx.$t('Squeeze.Prompts.Wildcard'),
                  onChange: _ctx.onCellValueChanged,
                  onShow: _ctx.showDropdownOverlay
                }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "placeholder", "onChange", "onShow"]))
              : (_openBlock(), _createBlock(_component_InputText, {
                  key: 1,
                  modelValue: slotProps.data.creditor,
                  "onUpdate:modelValue": ($event: any) => ((slotProps.data.creditor) = $event),
                  placeholder: _ctx.$t('Squeeze.Prompts.Wildcard'),
                  onInput: _ctx.onCellValueChanged
                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "onInput"]))
          ]),
          filter: _withCtx(({filterModel, filterCallback}) => [
            _createVNode(_component_InputText, {
              class: "p-column-filter filter-field",
              type: "text",
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
              style: {"min-width":"8rem"}
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
          ]),
          _: 1
        }, 8, ["header"]),
        (!_ctx.context)
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 3,
              field: "fieldName",
              filterField: "fieldName",
              header: _ctx.$t('Squeeze.XmlMapper.FieldName'),
              sortable: true,
              showFilterMenu: false,
              style: {"min-width":"10rem"}
            }, {
              body: _withCtx((slotProps) => [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createTextVNode(_toDisplayString(slotProps.data.fieldName), 1)
                ])), [
                  [
                    _directive_tooltip,
                    slotProps.data.fieldName,
                    void 0,
                    { bottom: true }
                  ]
                ])
              ]),
              editor: _withCtx((slotProps) => [
                _createVNode(_component_Dropdown, {
                  modelValue: slotProps.data.fieldName,
                  "onUpdate:modelValue": ($event: any) => ((slotProps.data.fieldName) = $event),
                  options: _ctx.fieldOptionsFor(slotProps.data),
                  optionValue: "name",
                  optionLabel: "name",
                  filter: true,
                  filterFields: ['name', 'translatedDescription', 'description'],
                  placeholder: _ctx.$t('Squeeze.XmlMapper.FieldName'),
                  onChange: _ctx.onCellValueChanged,
                  onShow: _ctx.showDropdownOverlay
                }, {
                  option: _withCtx((optionProps) => [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", null, _toDisplayString(optionProps.option.name), 1),
                      (_ctx.getTranslatedDescription(optionProps.option))
                        ? (_openBlock(), _createElementBlock("small", _hoisted_5, " – " + _toDisplayString(_ctx.getTranslatedDescription(optionProps.option)), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "onUpdate:modelValue", "options", "placeholder", "onChange", "onShow"])
              ]),
              filter: _withCtx(({filterModel, filterCallback}) => [
                _createVNode(_component_InputText, {
                  class: "p-column-filter filter-field",
                  type: "text",
                  modelValue: filterModel.value,
                  "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                  onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
                  style: {"min-width":"9rem"}
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
              ]),
              _: 1
            }, 8, ["header"]))
          : _createCommentVNode("", true),
        _createVNode(_component_Column, {
          field: "dataType",
          filterField: "dataType",
          header: _ctx.$t('Squeeze.MasterData.FileType'),
          sortable: true,
          showFilterMenu: false,
          style: {"min-width":"8rem","max-width":"9rem"}
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_ctx.getDataTypeLabel(slotProps.data.dataType)), 1)
          ]),
          editor: _withCtx((slotProps) => [
            _createVNode(_component_Dropdown, {
              modelValue: slotProps.data.dataType,
              "onUpdate:modelValue": ($event: any) => ((slotProps.data.dataType) = $event),
              options: _ctx.dataTypes,
              optionValue: "id",
              optionLabel: "text",
              onChange: _ctx.onCellValueChanged,
              onShow: _ctx.showDropdownOverlay
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange", "onShow"])
          ]),
          filter: _withCtx(({filterModel, filterCallback}) => [
            _createVNode(_component_Dropdown, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              onChange: ($event: any) => (filterCallback()),
              options: _ctx.dataTypes,
              optionValue: "id",
              optionLabel: "text",
              class: "p-column-filter filter-field",
              showClear: true
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "options"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "prompt",
          filterField: "prompt",
          header: _ctx.$t('Squeeze.Prompts.Prompt'),
          sortable: true,
          showFilterMenu: false,
          class: "prompt-column",
          style: {"min-width":"12rem","max-width":"24rem"}
        }, {
          body: _withCtx((slotProps) => [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createTextVNode(_toDisplayString(slotProps.data.prompt), 1)
            ])), [
              [
                _directive_tooltip,
                slotProps.data.prompt,
                void 0,
                { bottom: true }
              ]
            ])
          ]),
          filter: _withCtx(({filterModel, filterCallback}) => [
            _createVNode(_component_InputText, {
              class: "p-column-filter filter-field",
              type: "text",
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
              style: {"min-width":"10rem"}
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "active",
          filterField: "active",
          header: _ctx.$t('Squeeze.System.Active'),
          sortable: true,
          showFilterMenu: false,
          headerClass: "header-center",
          style: {"min-width":"6rem","max-width":"7rem","text-align":"center"}
        }, {
          body: _withCtx((slotProps) => [
            _createVNode(_component_Checkbox, {
              modelValue: slotProps.data.active,
              "onUpdate:modelValue": ($event: any) => ((slotProps.data.active) = $event),
              binary: true,
              onChange: ($event: any) => (_ctx.onChangeActive(slotProps.data))
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          exportable: false,
          frozen: "",
          alignFrozen: "right",
          style: {"min-width":"7rem","max-width":"7rem","text-align":"right","z-index":"1"}
        }, {
          body: _withCtx((slotProps) => [
            _withDirectives(_createVNode(_component_Button, {
              icon: "mdi mdi-pencil-outline",
              class: "p-button-lg p-button-rounded p-button-success p-button-text",
              onClick: ($event: any) => (_ctx.openEntryDialog(slotProps.data))
            }, null, 8, ["onClick"]), [
              [
                _directive_tooltip,
                _ctx.$t('Squeeze.Locators.Edit'),
                void 0,
                { bottom: true }
              ]
            ]),
            _withDirectives(_createVNode(_component_Button, {
              icon: "mdi mdi-delete-outline",
              class: "p-button-lg p-button-rounded p-button-danger p-button-text",
              onClick: ($event: any) => (_ctx.openDeleteDialog(slotProps.data))
            }, null, 8, ["onClick"]), [
              [
                _directive_tooltip,
                _ctx.$t('Squeeze.General.Delete'),
                void 0,
                { bottom: true }
              ]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "loading", "selection", "onCellEditInit", "onCellEditComplete", "filters", "rows", "currentPageReportTemplate", "onPage"]),
    _createVNode(_component_DialogDelete, {
      showDialog: _ctx.deleteDialog,
      onOnClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.deleteDialog = false)),
      onOnConfirm: _cache[6] || (_cache[6] = ($event: any) => (_ctx.deleteEntry()))
    }, null, 8, ["showDialog"])
  ], 64))
}